import https from './index'
import qs from 'qs'

import  URLS from "./lz.js"

// URLS.FansGroupUrl = '/apitest'

// URLS.FansUpLoadUrl = '/apiupload'



/**
 *
 * @param {roomId} params
 * @returns
 * @description 开始直播(创建聊天室)
 */
export function livestart(data) {
    return https({
        url:URLS.rootApi + '/v2/live/start',
        method: "post",
        data,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 注册云账号
 */
export function registerIM(data) {
    return https({
        url:URLS.FansGroupUrl + '/communication/registerIM',
        method: "post",
        authToken:true,
        data,
    })
}
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 查询聊天室地址
 */
export function chatRoomAddress(params) {
    return https({
        url:URLS.FansGroupUrl + '/communication/chatRoomAddress',
        method: "get",
        authToken:true,
        params,
    })
}



// WEBPACK FOOTER //
// ./src/api/wyapi.js